import React from 'react'
import PropTypes from 'prop-types'

import Box from '../../Box'

import Main from './Main'
import Sidebar from './Sidebar'

const Columns = (props) => {
  const { boxProps, children, flexDirection, style } = props

  return (
    <Box flexDirection={flexDirection || ['column', 'column', 'row']} style={style} {...boxProps}>
      {children}
    </Box>
  )
}

Columns.propTypes = {
  boxProps: PropTypes.object,
  children: PropTypes.node,
  flexDirection: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  style: PropTypes.object,
}

Columns.Main = Main
Columns.Sidebar = Sidebar

export default Columns
